
import { Component, Prop } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import Product from '@/store/entities/baseInfo/Product';
import FavoriteItem from '@/store/entities/shoppingCart/FavoriteItem';
import SelectAuthMode from './product-list-select-auth-mode.vue';
import Util from '@/lib/util';

@Component({
  components: {
    SelectAuthMode
  }
})
export default class ProductList extends AbpBase {
  @Prop({ type: Object, default: new Object() }) product: Object;
  // @Prop({ type: Array, default: new Array<Product>() }) products: Array<Product>;
  @Prop({ type: Number, default: 4 }) columnCount: number;
  @Prop({ type: Number, default: 2 }) col: number;

  columnWidth: string = "23.26%";
  selectAuthModeModalShow: boolean = false;
  selectedProduct: Product = new Product();
  // loading: boolean = false;
  // list: Array<Product> = [];

  get tenant() {
    return Util.abp.multiTenancy.getTenantCookie();
  }

  get isStandardEdition() {
    return Util.isStandardEdition();
  }

  get transactionType() {
    return this.tenant.transactionType;
  }

  created() {
    // window.addEventListener('scroll', () => {
    //   if (this.isScollToBottom() && !this.loading) {
    //     this.loading = true;
    //     this.loadmore();
    //   }
    // });

    switch (this.columnCount) {
      case 1:
        this.columnWidth = '100%';
        break;
      case 2:
        this.columnWidth = '45%';
        break;
    }
  }

  handleAddToFavorite(product) {
    let favoriteItem = new FavoriteItem();
    favoriteItem.productId = product.id;
    favoriteItem.productNo = product.productNo;
    favoriteItem.productName = product.name;
    favoriteItem.productImageUrl = product.coverImageUrl;
    favoriteItem.unitPrice = product.unitPrice;
    favoriteItem.userId = this.$store.state.session.user.id;
    favoriteItem.userNo = Util.abp.session.getUserNoCookie();
    favoriteItem.wxUserId = 0;
    favoriteItem.wxAppUserId = 0;

    if (!product.isFavorited) {
      this.$store.dispatch({
        type: 'favoriteItem/create',
        data: favoriteItem
      }).then(data => {
        product.isFavorited = true;
        this.$Message.success({
          content: this.L('AddToFavoriteSuccessful', 'FeedeemShop')
        });
      }).catch(err => {
        if (err.toString().indexOf('409') > -1) {
          this.$Message.info({
            content: this.L('AlreadAddedToFavorite', 'FeedeemShop')
          });
        }
      });
    } else {
      this.$Message.success({
        content: this.L('AddToFavoriteSuccessful', 'FeedeemShop')
      });
    }
  }

  handleFindSimilarClick(product) {
    localStorage.setItem('similar-product-source', JSON.stringify(product));
    window.open('/similar-list?ctg=' + product.coverImageHash);
  }

  goDetailPage(product) {
    window.open("/product?id=" + product.productNo);
  }

  goCheckout(product: Product) {
    this.selectedProduct = product;

    // 虚拟商品交易，需要选择授权模式
    if (this.transactionType === 0) {
      this.selectAuthModeModalShow = true; // 选择授权模式
    } else {
      location.href = '/checkout?id=' + this.selectedProduct.productNo
    }
  }

  authModeSelected(e) {
    location.href = '/checkout?id=' + this.selectedProduct.productNo + '&authMode=' + e
  }


  // loadmore() {
  //   this.loading = true;
  //   setTimeout(() => {
  //     this.$emit('loadmore')
  //     this.loading = false;
  //   }, 1000);
  // }

  // isScollToBottom() {
  //   const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //   const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
  //   const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
  //   return scrollTop + clientHeight >= scrollHeight - 100;
  // }

}
